const KEY_CODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,

  ESCAPE: 27,
  SPACE: 32,

  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,

  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,

  DELETE: 46,

  NUMPAD_MULTIPLY: 106,
  NUMPAD_ADD: 107,
  NUMPAD_ENTER: 108,
  NUMPAD_SUBTRACT: 109,
  NUMPAD_DECIMAL: 110,
  NUMPAD_DIVIDE: 111,

  EQUAL_SIGN: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,

  LETTER_A: 65,
  LETTER_B: 66,
  LETTER_C: 67,
  LETTER_D: 68,
  LETTER_E: 69,
  LETTER_F: 70,
  LETTER_G: 71,
  LETTER_H: 72,
  LETTER_I: 73,
  LETTER_L: 76,
  LETTER_O: 79,
  LETTER_P: 80,
  LETTER_Q: 81,
  LETTER_R: 82,
  LETTER_S: 83,
  LETTER_T: 84,
  LETTER_U: 85,
  LETTER_V: 86,
  LETTER_X: 88,
  LETTER_Z: 90,
};

class Key {
  static fromEvent(event) {
    return new Key(event);
  }

  constructor(event) {
    this.keyCode = 'which' in event ? event.which : event.keyCode;
    this.shiftKey = event.shiftKey;
    this.metaKey = event.metaKey;
    this.ctrlKey = event.ctrlKey;
    this.altKey = event.altKey;
  }

  is(...codes) {
    return codes.includes(this.keyCode);
  }
}

const keyboard = {
  ...KEY_CODES,

  keyFromEvent(event) {
    return Key.fromEvent(event);
  },

  isKey(keyCode, ...codes) {
    return codes.includes(keyCode);
  },
};

export default keyboard;
